import { Container, Grid } from "@mui/material";
import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import SectionHeading from "../../Components/SectionHeading";

import aboutImg from "../../images/aboutImg.png"
import Aos from "aos";

const About = () => {
    useEffect(() =>{
        AOS.init({duration: 1500})
    })
    return(
        <div id="about" className="mt-5 pt-5">
            <Container>
                <Grid
                    container
                    justifyContent="flex-start"
                    alignContent="center"
                    className="mt-5"
                >
                    <Grid
                        xs={12}
                        sm={6}
                        className="align-self-center d-none d-sm-block pr-4"
                    >
                        <img 
                            src={aboutImg} 
                            className="img-fluid w-100" 
                            style={{maxWidth: 400}}
                            data-aos="zoom-in-up"
                        />
                    </Grid>
                    <Grid
                        xs={12}
                        sm={6}
                        className="align-self-center"
                        data-aos="fade-up"
                    >
                            <SectionHeading
                                subHeading="About Us"
                                heading="Design and Development" 
                            />
                            <p style={{maxWidth:460}}>
                                MetaSnooker has been designed from the ground-up to help bring an amazing virtual experience for all. Players can win tokens by setting up a wager with other online players. The game ships with 2D version that is considered to be a quite stable and versatile build which makes the game more accessible to a vast majority of people regardless of their hardware or connection.
                            </p>
                    </Grid>
                    <Grid
                        xs={12}
                        className="text-center align-self-center d-sm-none mt-4"
                    >
                        <img src={aboutImg} className="img-fluid w-100" style={{maxWidth: 400}} />
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}
export default About;